import ApiService from './api.service';

const BASE_URL = 'contract';

/**
 * ContractService — wrapper cho 3 endpoint Phase 1 (BE-025/026/029).
 * KHÔNG đụng tới các endpoint cũ (/contracts/*) đang dùng bởi Upsert.vue legacy.
 *
 * BE docs:
 * - docs/features/be-023-025-contract-request-flow.md (createFromRequest)
 * - docs/features/be-026-029-031-032-enhance.md (cancel + override price)
 */
export const ContractService = {
  /**
   * Detail HĐ — BE-024 controller `@Controller("contract")` + `@Get(":id")`.
   */
  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },

  /**
   * BE-025 — Convert Đề nghị (approved) → HĐ (pendingSignature).
   * @param {string} requestId
   * @param {Object} data { contractNumber, bankName?, loanAmount? }
   */
  createFromRequest(requestId, data) {
    return ApiService.post(`${BASE_URL}/from-request/${requestId}`, data);
  },

  /**
   * BE-026 — Cancel HĐ (set requiresRefund/requiresInvoiceCancellation theo state).
   * @param {string} id
   * @param {string} reason min 10 ký tự
   */
  cancel(id, reason) {
    return ApiService.post(`${BASE_URL}/${id}/cancel`, { reason });
  },

  /**
   * BE-029 — Override giá item (audit PRICE_OVERRIDE).
   * @param {string} contractId
   * @param {string} itemId
   * @param {Object} data { newPrice, reason } (reason min 10 ký tự)
   */
  overrideItemPrice(contractId, itemId, data) {
    return ApiService.patch(
      `${BASE_URL}/${contractId}/items/${itemId}/override-price`,
      data,
    );
  },

  /**
   * Luồng duyệt HĐMB — chuyển trạng thái HĐ (state machine 9 bước).
   * @param {string} id contractId
   * @param {Object} payload {
   *   toStatus,            // bắt buộc — state đích
   *   reason?,             // bắt buộc min 10 ký tự khi toStatus = 'cancelled'
   *   invoiceNo?, invoiceDate?, // bắt buộc khi toStatus = 'invoiced'
   * }
   */
  transition(id, payload) {
    return ApiService.post(`${BASE_URL}/${id}/transition`, payload);
  },

  /**
   * Lịch sử thao tác HĐ (audit) — STATE_TRANSITION / PRICE_OVERRIDE / CANCEL / EDIT_FIELD.
   * @param {string} id contractId
   */
  getHistory(id) {
    return ApiService.query(`${BASE_URL}/${id}/history`);
  },

  /**
   * Phân bổ chassis cho 1+ contract_details (xe CHASSIS_ENGINE) — cho phép
   * partial. Sau khi đủ chassis cho mọi xe + HĐ đang `deposited` → BE auto
   * transition sang `allocated`.
   * @param {string} id contractId
   * @param {Object} data { items: [{ contractDetailId, productChassisId }] }
   */
  allocateChassis(id, data) {
    return ApiService.post(`${BASE_URL}/${id}/allocate-chassis`, data);
  },

  /**
   * Gỡ xe / Hủy ghép — allocated → deposited (KHÔNG hủy HĐ).
   * payload: { reasonCategory, note }  (note min 10 ký tự)
   */
  unallocate(id, payload) {
    return ApiService.post(`${BASE_URL}/${id}/unallocate`, payload);
  },

  /**
   * Export HĐ ra file .docx theo mẫu VinFast VF_PC01.81.
   * Response là binary blob — caller phải trigger download.
   * @param {string} id contractId
   */
  exportDocx(id) {
    return ApiService.query(`${BASE_URL}/${id}/export-docx`, {
      responseType: 'blob',
    });
  },
};

export default ContractService;
